// extracted by mini-css-extract-plugin
module.exports = {"three-stack":"three-stack_three-stack__UIHJu","flexible":"three-stack_flexible__QMLS7"};